var _style, _g, _defs, _defs2, _line, _defs3, _defs4, _line2, _defs5, _defs6, _line3, _defs7, _defs8, _line4, _defs9, _defs10, _line5, _defs11, _defs12, _line6, _defs13, _defs14, _line7, _defs15, _defs16, _line8, _defs17, _defs18, _line9, _defs19, _defs20, _line10, _defs21, _defs22, _line11, _defs23, _defs24, _line12, _defs25, _defs26, _line13, _defs27, _defs28, _line14, _defs29, _defs30, _defs31, _defs32, _line15, _defs33, _defs34, _line16, _defs35, _defs36, _line17, _defs37, _defs38, _line18, _defs39, _defs40, _line19, _defs41, _defs42, _line20, _defs43, _defs44, _line21, _defs45, _defs46, _path, _rect, _polygon, _rect2, _defs47, _path2, _rect3, _polygon2, _defs48, _path3, _defs49, _defs50, _path4, _defs51, _path5, _defs52, _path6, _defs53, _path7, _defs54, _path8, _defs55, _path9, _polygon3, _polygon4, _defs56, _defs57, _path10, _defs58, _path11, _defs59, _path12, _rect4, _defs60, _path13, _defs61, _path14, _defs62, _path15, _defs63, _defs64, _path16, _defs65, _path17, _defs66, _path18, _defs67, _path19, _defs68, _path20, _defs69, _path21, _defs70, _path22, _defs71, _path23, _defs72, _defs73, _path24, _defs74, _path25, _defs75, _path26, _defs76, _path27, _line22, _defs77, _defs78, _defs79, _path28, _path29, _defs80, _path30, _polygon5, _rect5, _rect6, _rect7, _rect8, _rect9, _defs81, _defs82, _path31, _defs83, _path32, _defs84, _path33, _defs85, _path34, _defs86, _path35, _defs87, _path36, _defs88, _path37, _defs89, _defs90, _path38, _defs91, _path39, _polygon6, _rect10, _polygon7, _defs92, _path40, _defs93, _path41, _defs94, _path42, _defs95, _path43, _defs96, _path44, _defs97, _path45, _defs98, _path46, _defs99, _path47, _defs100, _path48, _defs101, _path49, _defs102, _path50, _defs103, _path51, _defs104, _path52, _defs105, _path53, _defs106, _path54, _defs107, _path55, _defs108, _path56, _defs109, _path57, _defs110, _path58, _defs111, _path59, _defs112, _path60, _defs113, _path61, _defs114, _path62, _defs115, _path63, _path64, _path65, _rect11, _polygon8, _polygon9, _polygon10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsHomeGripsNeu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 1133.2",
    style: {
      enableBackground: "new 0 0 1280 1133.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st1{opacity:0.8;clip-path:url(#SVGID_2_);}\r\n\t.st2{clip-path:url(#SVGID_4_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st3{opacity:0.8;clip-path:url(#SVGID_6_);}\r\n\t.st4{clip-path:url(#SVGID_8_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st5{opacity:0.8;clip-path:url(#SVGID_10_);}\r\n\t.st6{clip-path:url(#SVGID_12_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st7{opacity:0.5;clip-path:url(#SVGID_14_);}\r\n\t.st8{clip-path:url(#SVGID_16_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st9{opacity:0.8;clip-path:url(#SVGID_18_);}\r\n\t.st10{clip-path:url(#SVGID_20_);fill:none;stroke:#F1F1F1;stroke-width:2;}\r\n\t.st11{opacity:0.8;clip-path:url(#SVGID_22_);}\r\n\t.st12{clip-path:url(#SVGID_24_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st13{opacity:0.5;clip-path:url(#SVGID_26_);}\r\n\t.st14{clip-path:url(#SVGID_28_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st15{opacity:0.5;clip-path:url(#SVGID_30_);}\r\n\t.st16{clip-path:url(#SVGID_32_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st17{opacity:0.8;clip-path:url(#SVGID_34_);}\r\n\t.st18{clip-path:url(#SVGID_36_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st19{opacity:0.8;clip-path:url(#SVGID_38_);}\r\n\t.st20{clip-path:url(#SVGID_40_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st21{opacity:0.8;clip-path:url(#SVGID_42_);}\r\n\t.st22{clip-path:url(#SVGID_44_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st23{opacity:0.8;clip-path:url(#SVGID_46_);}\r\n\t.st24{clip-path:url(#SVGID_48_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st25{opacity:0.8;clip-path:url(#SVGID_50_);}\r\n\t.st26{clip-path:url(#SVGID_52_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st27{opacity:0.8;clip-path:url(#SVGID_54_);}\r\n\t.st28{clip-path:url(#SVGID_56_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st29{opacity:0.8;clip-path:url(#SVGID_62_);}\r\n\t.st30{clip-path:url(#SVGID_64_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st31{opacity:0.8;clip-path:url(#SVGID_66_);}\r\n\t.st32{clip-path:url(#SVGID_68_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st33{opacity:0.8;clip-path:url(#SVGID_70_);}\r\n\t.st34{clip-path:url(#SVGID_72_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st35{opacity:0.8;clip-path:url(#SVGID_74_);}\r\n\t.st36{clip-path:url(#SVGID_76_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st37{opacity:0.8;clip-path:url(#SVGID_78_);}\r\n\t.st38{clip-path:url(#SVGID_80_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st39{opacity:0.8;clip-path:url(#SVGID_82_);}\r\n\t.st40{clip-path:url(#SVGID_84_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st41{opacity:0.8;clip-path:url(#SVGID_86_);}\r\n\t.st42{clip-path:url(#SVGID_88_);fill:none;stroke:#DADADA;stroke-width:2;}\r\n\t.st43{clip-path:url(#SVGID_92_);fill:#144478;}\r\n\t.st44{fill:#2F5285;}\r\n\t.st45{clip-path:url(#SVGID_94_);fill:#0C2D54;}\r\n\t.st46{fill:#FFFFFF;}\r\n\t.st47{clip-path:url(#SVGID_96_);fill:#FFFFFF;}\r\n\t.st48{clip-path:url(#SVGID_100_);fill:#144478;}\r\n\t.st49{clip-path:url(#SVGID_102_);fill:#0C2D54;}\r\n\t.st50{clip-path:url(#SVGID_104_);fill:#FFFFFF;}\r\n\t.st51{clip-path:url(#SVGID_106_);fill:#EEEFF1;}\r\n\t.st52{clip-path:url(#SVGID_108_);fill:#EEEFF1;}\r\n\t.st53{clip-path:url(#SVGID_110_);fill:#2F5285;}\r\n\t.st54{fill:#EEEFF1;}\r\n\t.st55{clip-path:url(#SVGID_114_);fill:#144478;}\r\n\t.st56{clip-path:url(#SVGID_116_);fill:#0C2D54;}\r\n\t.st57{clip-path:url(#SVGID_118_);fill:#FFFFFF;}\r\n\t.st58{clip-path:url(#SVGID_120_);fill:#FFFFFF;}\r\n\t.st59{clip-path:url(#SVGID_122_);fill:#2F5285;}\r\n\t.st60{clip-path:url(#SVGID_124_);fill:#2F5285;}\r\n\t.st61{clip-path:url(#SVGID_128_);fill:#DADADA;}\r\n\t.st62{clip-path:url(#SVGID_130_);fill:#A8A8A7;}\r\n\t.st63{clip-path:url(#SVGID_132_);fill:#FFFFFF;}\r\n\t.st64{clip-path:url(#SVGID_134_);fill:#FFFFFF;}\r\n\t.st65{clip-path:url(#SVGID_136_);fill:#FFFFFF;}\r\n\t.st66{clip-path:url(#SVGID_138_);fill:#FFFFFF;}\r\n\t.st67{clip-path:url(#SVGID_140_);fill:#FFFFFF;}\r\n\t.st68{clip-path:url(#SVGID_142_);fill:#FFFFFF;}\r\n\t.st69{clip-path:url(#SVGID_146_);fill:#DADADA;}\r\n\t.st70{clip-path:url(#SVGID_148_);fill:#A8A8A7;}\r\n\t.st71{clip-path:url(#SVGID_150_);fill:#FFFFFF;}\r\n\t.st72{clip-path:url(#SVGID_152_);fill:#FFFFFF;}\r\n\t.st73{clip-path:url(#SVGID_158_);fill:#00376D;}\r\n\t.st74{fill:#0C2D54;}\r\n\t.st75{clip-path:url(#SVGID_160_);fill:#0C2D54;}\r\n\t.st76{fill:#425F90;}\r\n\t.st77{clip-path:url(#SVGID_164_);fill:#00376D;}\r\n\t.st78{clip-path:url(#SVGID_166_);fill:#0C2D54;}\r\n\t.st79{clip-path:url(#SVGID_168_);fill:#E3E9EC;}\r\n\t.st80{clip-path:url(#SVGID_170_);fill:#FFFFFF;}\r\n\t.st81{clip-path:url(#SVGID_172_);fill:#FFFFFF;}\r\n\t.st82{clip-path:url(#SVGID_174_);fill:#FFFFFF;}\r\n\t.st83{clip-path:url(#SVGID_176_);fill:#425F90;}\r\n\t.st84{clip-path:url(#SVGID_180_);fill:#DADADA;}\r\n\t.st85{clip-path:url(#SVGID_182_);fill:#A8A8A7;}\r\n\t.st86{fill:#BDBCBC;}\r\n\t.st87{clip-path:url(#SVGID_184_);fill:#FFFFFF;}\r\n\t.st88{clip-path:url(#SVGID_186_);fill:#FFFFFF;}\r\n\t.st89{clip-path:url(#SVGID_188_);fill:#FFFFFF;}\r\n\t.st90{clip-path:url(#SVGID_190_);fill:#FFFFFF;}\r\n\t.st91{clip-path:url(#SVGID_192_);fill:#FFFFFF;}\r\n\t.st92{clip-path:url(#SVGID_194_);fill:#FFFFFF;}\r\n\t.st93{clip-path:url(#SVGID_196_);fill:#FFFFFF;}\r\n\t.st94{clip-path:url(#SVGID_198_);fill:#FFFFFF;}\r\n\t.st95{clip-path:url(#SVGID_200_);fill:#FFFFFF;}\r\n\t.st96{clip-path:url(#SVGID_202_);fill:#FFFFFF;}\r\n\t.st97{clip-path:url(#SVGID_204_);fill:#FFFFFF;}\r\n\t.st98{clip-path:url(#SVGID_206_);fill:#FFFFFF;}\r\n\t.st99{clip-path:url(#SVGID_208_);fill:#FFFFFF;}\r\n\t.st100{clip-path:url(#SVGID_210_);fill:#FFFFFF;}\r\n\t.st101{clip-path:url(#SVGID_212_);fill:#FFFFFF;}\r\n\t.st102{clip-path:url(#SVGID_214_);fill:#FFFFFF;}\r\n\t.st103{clip-path:url(#SVGID_216_);fill:#FFFFFF;}\r\n\t.st104{clip-path:url(#SVGID_218_);fill:#144478;}\r\n\t.st105{clip-path:url(#SVGID_220_);fill:#144478;}\r\n\t.st106{clip-path:url(#SVGID_222_);fill:#144478;}\r\n\t.st107{clip-path:url(#SVGID_224_);fill:#144478;}\r\n\t.st108{clip-path:url(#SVGID_226_);fill:#0C2D54;}\r\n\t.st109{clip-path:url(#SVGID_228_);fill:#FFFFFF;}\r\n\t.st110{clip-path:url(#SVGID_230_);fill:#0C2D54;}\r\n\t.st111{fill:#A8A8A7;}\r\n\t.st112{fill:#DADADA;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1179.6,
    y1: 1010.3,
    x2: 1280,
    y2: 870.4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 1152.6,
    y: 539.3,
    width: 29,
    height: 472.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 1154.6,
    y1: 540.3,
    x2: 1179.6,
    y2: 1010.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 1097.6,
    y: 744,
    width: 83.9,
    height: 267.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1099.6,
    y1: 745.3,
    x2: 1179.6,
    y2: 1010.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: 1178.6,
    y: 1007.1,
    width: 177.8,
    height: 204.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 1180.3,
    y1: 1008.7,
    x2: 1354.6,
    y2: 1210.2
  })))))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: 582.6,
    y: 59.2,
    width: 59,
    height: 477.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 584.6,
    y1: 60.3,
    x2: 639.6,
    y2: 535.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: 637.8,
    y: 253.8,
    width: 183.7,
    height: 278.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 819.6,
    y1: 255.3,
    x2: 639.6,
    y2: 530.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_21_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: 817.7,
    y: 258.8,
    width: 108.7,
    height: 178
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 819.6,
    y1: 260.3,
    x2: 924.6,
    y2: 435.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: 578,
    y: 63.6,
    width: 243.2,
    height: 193.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 579.6,
    y1: 65.3,
    x2: 819.6,
    y2: 255.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_31_",
    x: 578.6,
    y: 63.3,
    width: 357.1,
    height: 19
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 579.6,
    y1: 65.3,
    x2: 934.6,
    y2: 80.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_33_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_35_",
    x: 817.8,
    y: 78.8,
    width: 118.7,
    height: 178.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 934.6,
    y1: 80.3,
    x2: 819.6,
    y2: 255.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_37_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_39_",
    x: 938.3,
    y: 73.4,
    width: 247.5,
    height: 68.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 939.6,
    y1: 75.3,
    x2: 1184.6,
    y2: 140.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_41_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_43_",
    x: 1112.7,
    y: 139,
    width: 68.9,
    height: 192.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 1179.6,
    y1: 140.3,
    x2: 1114.6,
    y2: 330.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_45_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_47_",
    x: 1107.6,
    y: 329.2,
    width: 44,
    height: 222.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    style: {
      overflow: "visible"
    }
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st24",
    x1: 1109.6,
    y1: 330.3,
    x2: 1149.6,
    y2: 550.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_49_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_51_",
    x: 918.1,
    y: 428.4,
    width: 237.9,
    height: 123.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_52_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    style: {
      overflow: "visible"
    }
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 1154.6,
    y1: 550.3,
    x2: 919.6,
    y2: 430.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_53_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_54_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_53_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_55_",
    x: 638.3,
    y: 428.4,
    width: 287.6,
    height: 98.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_56_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_55_",
    style: {
      overflow: "visible"
    }
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 924.6,
    y1: 430.3,
    x2: 639.6,
    y2: 525.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_57_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_58_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_57_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_59_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_60_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_59_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_61_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_62_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_61_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st29"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_63_",
    x: 818.4,
    y: 253.4,
    width: 297.5,
    height: 78.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_64_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_63_",
    style: {
      overflow: "visible"
    }
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: 819.6,
    y1: 255.3,
    x2: 1114.6,
    y2: 330.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_65_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_66_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_65_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st31"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_67_",
    x: 823.3,
    y: 133.4,
    width: 362.6,
    height: 118.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_68_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_67_",
    style: {
      overflow: "visible"
    }
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st32",
    x1: 824.6,
    y1: 250.3,
    x2: 1184.6,
    y2: 135.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_69_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_70_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_69_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st33"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_71_",
    x: 1113.3,
    y: 283.4,
    width: 192.5,
    height: 53.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_72_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_71_",
    style: {
      overflow: "visible"
    }
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st34",
    x1: 1114.6,
    y1: 335.3,
    x2: 1304.6,
    y2: 285.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_73_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_74_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_73_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st35"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_75_",
    x: 1183,
    y: 18.6,
    width: 138.3,
    height: 118.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_76_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_75_",
    style: {
      overflow: "visible"
    }
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st36",
    x1: 1184.6,
    y1: 135.3,
    x2: 1319.6,
    y2: 20.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_77_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_78_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_77_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st37"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_79_",
    x: 1163.1,
    y: 543.5,
    width: 168,
    height: 98.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_80_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_79_",
    style: {
      overflow: "visible"
    }
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st38",
    x1: 1164.6,
    y1: 545.3,
    x2: 1329.6,
    y2: 640.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_81_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_82_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_81_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_83_",
    x: 912.7,
    y: 443.8,
    width: 188.7,
    height: 303
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_84_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_83_",
    style: {
      overflow: "visible"
    }
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "st40",
    x1: 914.6,
    y1: 445.3,
    x2: 1099.6,
    y2: 745.3
  })))))), /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_85_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_86_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_85_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_87_",
    x: 1097.6,
    y: 539.1,
    width: 58.9,
    height: 207.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_88_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_87_",
    style: {
      overflow: "visible"
    }
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "st42",
    x1: 1154.6,
    y1: 540.3,
    x2: 1099.6,
    y2: 745.3
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_89_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_90_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_89_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_91_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_92_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_91_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M1144.6,330.3c0,16.6-13.4,30-30,30c-2.4,0-4.8-0.3-7.1-0.8c-13.1-3.2-22.9-15-22.9-29.2 c0-16.6,13.4-30,30-30c15.3,0,27.9,11.4,29.8,26.2C1144.5,327.8,1144.6,329.1,1144.6,330.3"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1106.6,
    y: 319.7,
    className: "st44",
    width: 15,
    height: 20.8
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "1104.2,340.5 1102.5,340.5 1102.5,315.8 1104.2,316.7 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1124.1,
    y: 314.5,
    className: "st44",
    width: 1.7,
    height: 26
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_93_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_94_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_93_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M1144.6,330.3c0,16.6-13.4,30-30,30c-2.1,0-4.2-0.2-6.2-0.6l-10.5-10.5h32.4v-36.7l14,14c0,0,0,0,0,0.1 C1144.5,327.8,1144.6,329.1,1144.6,330.3"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1102.5,
    y: 340.5,
    className: "st46",
    width: 23.2,
    height: 4.1
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "1121,312.5 1121,317.8 1107.3,317.8 1107.3,314.9 1097.9,309.5 1097.9,307.1 1107.3,312.5 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_95_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_96_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_95_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M1128,346.8h-27.7v-32.3l3.9,2.3V343h19.9v-28.4h3.9L1128,346.8L1128,346.8z M1121.7,312.5v22.6 c0,2.9-2.4,5.3-5.3,5.3h-4.4c-2.9,0-5.3-2.4-5.3-5.3v-19.8l-8.7-5v38.9h32.4v-36.7H1121.7z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_97_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_98_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_97_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_99_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_100_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_99_",
    style: {
      overflow: "visible"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M999.6,85.3c0,33.1-26.9,60-60,60l0,0c-33.1,0-60-26.9-60-60s26.9-60,60-60c30.4,0,55.5,22.6,59.4,51.8 C999.4,79.8,999.6,82.6,999.6,85.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_101_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_102_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_101_",
    style: {
      overflow: "visible"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M999.6,87.7c-0.9,24.3-16.3,44.9-37.8,53.4L939.6,119c1.1-0.6,30.5-16.2,30.5-60.7l0.1,0.1L999.6,87.7z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_103_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_104_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_103_",
    style: {
      overflow: "visible"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M939.6,46.2V119c0,0-30.5-15.4-30.5-60.7c12.4,0,21-8.2,25.8-10.9C936.3,46.6,938,46.2,939.6,46.2"
  }))), /*#__PURE__*/React.createElement("g", null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_105_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_106_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_105_",
    style: {
      overflow: "visible"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M939.6,46.2V119l0,0l0,0l0,0c0,0,0.5-0.2,1.3-0.7c5.8-3.5,29.3-20.3,29.3-60l0,0l0,0 c-12.4,0-21-8.2-25.8-10.9C942.9,46.6,941.2,46.2,939.6,46.2"
  }))), /*#__PURE__*/React.createElement("g", null, _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_107_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_108_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_107_",
    style: {
      overflow: "visible"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M970.2,58.3c0,39.7-23.5,56.5-29.3,60C946.6,114.7,970.2,98,970.2,58.3L970.2,58.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_109_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_110_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_109_",
    style: {
      overflow: "visible"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M937.6,93.1l-8.5-7.2c-0.6-0.5-0.6-1.3-0.1-1.9l1.9-2.3c0.5-0.6,1.3-0.6,1.9-0.1l5,4.2l11.8-15.9 c0.4-0.6,1.3-0.7,1.9-0.3l2.4,1.8c0.6,0.4,0.7,1.3,0.3,1.9L939.6,93C939.1,93.5,938.2,93.6,937.6,93.1"
  })))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "939.6,119 939.6,119 939.6,118.9 939.6,118.9 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "939.6,119 939.6,119 939.6,118.9 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_111_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_112_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_111_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs57 || (_defs57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_113_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_114_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_113_",
    style: {
      overflow: "visible"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M859.6,255.3c0,0.6,0,1.2,0,1.8c-0.9,19.5-15.6,35.3-34.6,37.8c-1.8,0.2-3.5,0.4-5.4,0.4 c-22.1,0-40-17.9-40-40s17.9-40,40-40C841.7,215.3,859.6,233.2,859.6,255.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs58 || (_defs58 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_115_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_116_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_115_",
    style: {
      overflow: "visible"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M859.6,257.1c-0.9,19.5-15.6,35.3-34.6,37.8l-18.7-18.7c0.4,0.4,1,0.6,1.6,0.6h22c1.5,0,2.7-1.2,2.7-2.7v-43 c0-0.5-0.1-1-0.4-1.4L859.6,257.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs59 || (_defs59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_117_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_118_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_117_",
    style: {
      overflow: "visible"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M830.5,271.9h-23.3v-39.5h23.3V271.9z M818.9,276.3c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9 c1,0,1.9,0.8,1.9,1.9C820.8,275.4,819.9,276.3,818.9,276.3 M829.9,228.5h-22c-1.5,0-2.7,1.2-2.7,2.7v43c0,1.5,1.2,2.7,2.7,2.7h22 c1.5,0,2.7-1.2,2.7-2.7v-43C832.6,229.7,831.4,228.5,829.9,228.5"
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 807.3,
    y: 232.4,
    className: "st44",
    width: 23.3,
    height: 39.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs60 || (_defs60 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_119_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_120_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_119_",
    style: {
      overflow: "visible"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M820.3,274.4c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4S820.3,273.6,820.3,274.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs61 || (_defs61 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_121_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_122_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_121_",
    style: {
      overflow: "visible"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M820.8,231.1H817c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h3.9c0.3,0,0.5,0.2,0.5,0.5 C821.3,230.8,821.1,231.1,820.8,231.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs62 || (_defs62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_123_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_124_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_123_",
    style: {
      overflow: "visible"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M815.7,230.6c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5S815.7,230.3,815.7,230.6"
  }))), /*#__PURE__*/React.createElement("g", null, _defs63 || (_defs63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_125_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_126_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_125_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs64 || (_defs64 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_127_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_128_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_127_",
    style: {
      overflow: "visible"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M1229.6,141.3c0,1.2,0,2.3-0.1,3.5c-1.3,18.7-12.9,34.6-29.2,42.1c-6.3,2.9-13.3,4.5-20.7,4.5 c-27.6,0-50-22.4-50-50s22.4-50,50-50C1207.2,91.3,1229.6,113.7,1229.6,141.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs65 || (_defs65 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_129_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_130_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_129_",
    style: {
      overflow: "visible"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M1229.5,144.8c-1.2,18.1-12.1,33.5-27.4,41.2l-22.2-22.2c1.5-0.1,2.9-0.6,4-1.8c2.4-2.4,2.4-6.2,0-8.5 c-1.2-1.2-2.7-1.8-4.3-1.8v-7.9c3.6,0,7.2,1.4,9.9,4.1c1,1,2.7,1,3.7,0s1-2.7,0-3.7c-3.8-3.8-8.7-5.6-13.6-5.6v-7.8 c7.2,0,14,2.8,19.1,7.9c1,1,2.7,1,3.7,0s1-2.7,0-3.7c-6.1-6.1-14.2-9.4-22.8-9.4v-7.1c10.1,0,20.1,3.8,27.8,11.5c1,1,2.7,1,3.7,0 c1-0.9,1-2.5,0.2-3.5L1229.5,144.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs66 || (_defs66 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_131_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_132_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_131_",
    style: {
      overflow: "visible"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M1207.2,122.9c-17.5-13.8-42.9-12.6-59,3.5c-1,1-1,2.7,0,3.7c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.3-0.3,1.8-0.8 c7.7-7.7,17.7-11.5,27.8-11.5c6.9,0,13.8,1.8,20,5.4c0.6,0.3,1.1,0.7,1.7,1c0.8,0.5,1.6,1.1,2.4,1.7c0.5,0.4,1,0.8,1.5,1.3 c0.4,0.3,0.8,0.7,1.1,1c0.4,0.3,0.7,0.7,1.1,1c1,1,2.7,1,3.7,0c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.2-0.3,0.2-0.4 c0-0.1,0.1-0.2,0.1-0.2c0.1-0.3,0.1-0.6,0.1-1c0-0.1,0-0.3-0.1-0.4c-0.1-0.3-0.2-0.5-0.3-0.8c0-0.1-0.1-0.1-0.2-0.2l-0.1-0.1 l-0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1c-0.3-0.3-0.6-0.6-0.9-0.9s-0.6-0.5-0.9-0.8c0,0,0,0-0.1,0L1207.2,122.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs67 || (_defs67 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_133_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_134_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_133_",
    style: {
      overflow: "visible"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M1158.7,139.5c-0.7,0-1.3-0.3-1.8-0.8c-1-1-1-2.7,0-3.7c6.1-6.1,14.2-9.4,22.8-9.4l0,0 c8.6,0,16.7,3.3,22.8,9.4c1,1,1,2.7,0,3.7s-2.7,1-3.7,0c-5.1-5.1-11.9-7.9-19.1-7.9l0,0c-7.2,0-14,2.8-19.1,7.9 C1160,139.3,1159.3,139.5,1158.7,139.5"
  }))), /*#__PURE__*/React.createElement("g", null, _defs68 || (_defs68 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_135_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_136_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_135_",
    style: {
      overflow: "visible"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M1167.8,148.7c-0.7,0-1.3-0.3-1.8-0.8c-1-1-1-2.7,0-3.7c7.5-7.5,19.7-7.5,27.2,0c1,1,1,2.7,0,3.7 s-2.7,1-3.7,0c-5.5-5.5-14.4-5.5-19.9,0C1169.2,148.4,1168.5,148.7,1167.8,148.7"
  }))), /*#__PURE__*/React.createElement("g", null, _defs69 || (_defs69 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_137_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_138_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_137_",
    style: {
      overflow: "visible"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M1179.6,151.7c-1.5,0-3.1,0.6-4.3,1.8c-2.4,2.4-2.4,6.2,0,8.5c1.2,1.2,2.7,1.8,4.3,1.8 c1.5,0,3.1-0.6,4.3-1.8c2.4-2.4,2.4-6.2,0-8.5C1182.7,152.3,1181.1,151.7,1179.6,151.7"
  }))), /*#__PURE__*/React.createElement("g", null, _defs70 || (_defs70 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_139_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_140_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_139_",
    style: {
      overflow: "visible"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M1208.9,124.3C1208.9,124.3,1208.9,124.4,1208.9,124.3L1208.9,124.3L1208.9,124.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs71 || (_defs71 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_141_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_142_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_141_",
    style: {
      overflow: "visible"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M1211.2,126.5l-0.4-0.4C1210.9,126.2,1211,126.3,1211.2,126.5C1211.1,126.4,1211.1,126.5,1211.2,126.5"
  }))), /*#__PURE__*/React.createElement("g", null, _defs72 || (_defs72 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_143_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_144_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_143_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs73 || (_defs73 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_145_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_146_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_145_",
    style: {
      overflow: "visible"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M614.6,65.3c0,0.2,0,0.3,0,0.5c-0.2,14.5-10.8,26.6-24.7,29.1c-1.7,0.3-3.5,0.5-5.3,0.5 c-16.6,0-30-13.4-30-30s13.4-30,30-30C601.2,35.3,614.6,48.8,614.6,65.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs74 || (_defs74 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_147_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_148_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_147_",
    style: {
      overflow: "visible"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M614.6,65.8c-0.2,14.5-10.7,26.5-24.6,29l-13.2-13.3h3.4l0.3-1.8c0.9-0.2,1.7-0.5,2.5-0.8l1.1,1.3l2.9-2 l-0.9-1.5c0.6-0.7,1.2-1.4,1.6-2.3l1.8,0.6l1.1-3.4l-1.7-0.6c0.1-1,0.2-1.9,0-2.8l1.6-0.9l-1.1-3.1l-1.8,0.2L587,63l1.5-1l0.7,1 l1.2-0.7l0.7,0.6l0.9,0.5l-0.2,1.3l2.3,0.7l0.6-1.2c0.6,0.1,1.3,0.1,1.9,0l0.5,1.1l2.4-0.8l-0.3-1.2c0.6-0.3,1.1-0.7,1.6-1.2 l1.1,0.8l1.5-2.1l-1-0.8c0.3-0.6,0.5-1.3,0.6-1.9l1.3-0.3l-0.1-2.3L614.6,65.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs75 || (_defs75 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_149_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_150_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_149_",
    style: {
      overflow: "visible"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M580.3,58.8L580.3,58.8l-0.1-1.6h-3.4l-0.2,1.6c-1,0.2-1.9,0.5-2.7,0.9l-1.1-1.1l-2.6,2l0.5,1.4 c-0.6,0.7-1.2,1.4-1.6,2.3l-1.9-0.3l-1.1,3.3l1.8,0.6c-0.1,0.9-0.1,1.9,0,2.8l-1.6,0.7l1,3.5l1.8-0.3c0.4,0.7,0.9,1.4,1.5,2.1 l-0.8,1.6l2.8,2.1l1.3-1.4c0.4,0.2,0.8,0.3,1.2,0.5c0.4,0.1,0.9,0.3,1.4,0.3l0.3,1.8h3.4l0.3-1.8c0.9-0.2,1.7-0.5,2.5-0.8l1.1,1.2 l2.9-2l-0.9-1.5c0.6-0.7,1.2-1.4,1.6-2.3l1.8,0.6l1.1-3.4l-1.7-0.6c0.1-0.9,0.2-1.9,0-2.8l1.6-0.9l-1.1-3.1l-1.8,0.2 c-0.4-0.8-1-1.6-1.6-2.2l1-1.6l-2.9-2l-1.2,1.3c-0.4-0.2-0.9-0.4-1.4-0.5C581.2,59,580.7,58.9,580.3,58.8 M580.6,62.8 c3.7,1.2,5.7,5.1,4.5,8.8s-5.1,5.7-8.8,4.5s-5.7-5.1-4.5-8.8C573,63.6,576.9,61.6,580.6,62.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs76 || (_defs76 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_151_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_152_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_151_",
    style: {
      overflow: "visible"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M599,49.8L599,49.8l0.3-1.1L597,48l-0.5,1.1c-0.7-0.1-1.4-0.1-2.1,0l-0.6-1l-2.2,0.9l0.1,1 c-0.6,0.3-1.1,0.7-1.6,1.2l-1.2-0.6l-1.4,2l1.1,0.8c-0.3,0.6-0.5,1.3-0.6,1.9l-1.2,0.2v2.6l1.3,0.2c0.1,0.6,0.3,1.2,0.6,1.7 l-0.9,0.9l1.5,2.1l1.2-0.7c0.2,0.2,0.5,0.4,0.7,0.6c0.3,0.2,0.6,0.4,0.9,0.5l-0.2,1.3l2.3,0.7l0.6-1.2c0.6,0.1,1.3,0,1.9,0 l0.5,1.1l2.4-0.8l-0.3-1.2c0.6-0.3,1.1-0.7,1.6-1.2l1.1,0.8l1.5-2.1l-1-0.8c0.3-0.6,0.5-1.3,0.6-1.9l1.3-0.3l-0.1-2.3l-1.2-0.3 c-0.1-0.6-0.3-1.3-0.6-1.9l1-0.9l-1.5-2l-1.1,0.6c-0.3-0.2-0.5-0.5-0.8-0.7C599.6,50.1,599.3,50,599,49.8 M598.4,52.6 c2.3,1.6,2.8,4.7,1.2,7s-4.7,2.8-7,1.2s-2.8-4.7-1.2-7S596.1,51,598.4,52.6"
  })))), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 634.6,
    y1: 520.3,
    x2: 1099.6,
    y2: 745.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs77 || (_defs77 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_153_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_154_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_153_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs78 || (_defs78 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_155_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_156_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_155_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs79 || (_defs79 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_157_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_158_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_157_",
    style: {
      overflow: "visible"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M979.6,431.3c0,33.1-26.9,59.9-60,59.9s-60-26.8-60-59.9s26.9-59.9,60-59.9 C952.7,371.3,979.6,398.2,979.6,431.3"
  })))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M948.8,395.4L948.8,395.4L948.8,395.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs80 || (_defs80 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_159_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_160_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_159_",
    style: {
      overflow: "visible"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M979.6,431.4c0,14.1-4.9,27.1-13.1,37.3c-0.7,0.8-1.3,1.6-2,2.4l0,0c-0.6,0.7-1.2,1.3-1.8,2 c-0.8,0.8-1.6,1.6-2.4,2.4c-10.6,9.8-24.8,15.8-40.3,15.8l-29.6-29.6h58.4v-66.4l30.6,30.5C979.5,427.7,979.6,429.6,979.6,431.4"
  })))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "948.8,395.4 948.8,461.8 890.4,461.8 890.4,395.4 895.2,395.4 895.2,457 944,457 944,395.4 "
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 895.2,
    y: 426.2,
    className: "st76",
    width: 48.9,
    height: 30.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 880.8,
    y: 409.5,
    className: "st46",
    width: 9.5,
    height: 9.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 880.8,
    y: 408.4,
    className: "st46",
    width: 2.4,
    height: 11.9
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 948.8,
    y: 409.5,
    className: "st46",
    width: 9.5,
    height: 9.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 956,
    y: 408.4,
    className: "st46",
    width: 2.4,
    height: 11.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs81 || (_defs81 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_161_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_162_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_161_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs82 || (_defs82 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_163_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_164_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_163_",
    style: {
      overflow: "visible"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M1134.6,745.3c0,22.1-17.9,40-40,40s-40-17.9-40-40s17.9-40,40-40S1134.6,723.2,1134.6,745.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs83 || (_defs83 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_165_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_166_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_165_",
    style: {
      overflow: "visible"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M1134.6,745.3c0,0.9,0,1.9-0.1,2.8c-0.1,2-0.4,4-0.9,5.9c-2,9.3-7.3,17.4-14.6,23c-2.4,1.9-5.1,3.5-7.9,4.8 c-4.9,2.2-10.3,3.5-16,3.6c-0.2-0.1-0.4,0-0.6,0s-0.4,0-0.6,0l-9.3-9.7l9.9-5.9l9.9,5.9v-17.8c0.4-0.1,0.8-0.2,1.1-0.3 c1.3-0.7,2.8-3.3,3.8-4.2c1.1-0.9,3.9-2.1,4.7-3.3c0.8-1.2,0.9-4.2,1.4-5.5s2.4-3.7,2.6-5.1c0.2-1.4-1.1-4.1-1.3-5.6 c-0.2-1.4,0.5-4.4-0.1-5.7c-0.1-0.3-0.3-0.6-0.6-0.9l0,0l0.1-0.2L1134.6,745.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs84 || (_defs84 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_167_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_168_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_167_",
    style: {
      overflow: "visible"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M1104.5,758.7v16.9l-9.9-5.9v-8.6c1,0,2.4-0.6,3.6-1.2c0.7-0.3,1.4-0.7,1.9-0.8s1.3-0.2,2.1-0.2 C1103,758.9,1103.8,758.8,1104.5,758.7"
  }))), /*#__PURE__*/React.createElement("g", null, _defs85 || (_defs85 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_169_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_170_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_169_",
    style: {
      overflow: "visible"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M1094.6,761.1v8.6l-9.9,5.9v-16.9c0.7,0.1,1.5,0.1,2.3,0.2c0.8,0,1.6,0.1,2.1,0.2c0.5,0.1,1.2,0.5,1.9,0.8 C1092.2,760.5,1093.5,761.1,1094.6,761.1"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs86 || (_defs86 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_171_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_172_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_171_",
    style: {
      overflow: "visible"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M1094.6,714.2c1.4,0,4.3-1,5.7-0.6c1.4,0.3,3.5,2.5,4.7,3.2c1.3,0.7,4.2,1.1,5.3,2.1c1.1,0.9,1.9,3.8,2.7,5 c0.8,1.2,3.2,3,3.7,4.3s-0.1,4.3,0.1,5.7s1.5,4.1,1.3,5.6c-0.2,1.4-2.1,3.7-2.6,5.1c-0.5,1.3-0.6,4.3-1.4,5.5s-3.6,2.3-4.7,3.3 c-1.1,0.9-2.6,3.6-3.8,4.2c-1.3,0.7-4.3,0.4-5.7,0.7s-3.9,2-5.4,2c-1.4,0-4-1.6-5.4-2c-1.4-0.3-4.4-0.1-5.7-0.7 c-1.3-0.7-2.8-3.3-3.8-4.2c-1.1-0.9-3.9-2.1-4.7-3.3c-0.8-1.2-0.9-4.2-1.4-5.5s-2.4-3.7-2.6-5.1c-0.2-1.4,1.1-4.1,1.3-5.6 c0.2-1.4-0.5-4.4,0.1-5.7c0.5-1.3,2.9-3.1,3.7-4.3c0.8-1.2,1.6-4.1,2.7-5s4.1-1.4,5.3-2.1c1.3-0.7,3.3-2.9,4.7-3.2 C1090.3,713.2,1093.2,714.2,1094.6,714.2"
  }))), /*#__PURE__*/React.createElement("g", null, _defs87 || (_defs87 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_173_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_174_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_173_",
    style: {
      overflow: "visible"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M1115.1,736.8c0-11.3-9.2-20.5-20.5-20.5s-20.5,9.2-20.5,20.5s9.2,20.5,20.5,20.5 C1105.9,757.4,1115.1,748.2,1115.1,736.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs88 || (_defs88 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_175_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_176_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_175_",
    style: {
      overflow: "visible"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M1105.4,753c-0.3,0.2-0.6,0.4-0.9,0.5c-0.3,0.2-0.6,0.4-0.9,0.5c-0.1,0.1-0.2,0.1-0.3,0.1 c-2.6,1.3-5.6,2.1-8.7,2.1s-6.1-0.7-8.7-2.1c-0.1,0-0.2-0.1-0.3-0.1c-0.3-0.2-0.6-0.3-0.9-0.5c-5.7-3.4-9.6-9.6-9.6-16.7 c0-10.7,8.7-19.5,19.5-19.5c9.1,0,16.8,6.3,18.9,14.7c0.4,1.5,0.6,3.1,0.6,4.7C1114.1,743.6,1110.6,749.5,1105.4,753  M1114.2,730.7c-2.6-8.4-10.4-14.5-19.6-14.5c-11.3,0-20.5,9.2-20.5,20.5c0,7.8,4.3,14.5,10.6,18c2.9,1.6,6.3,2.5,9.9,2.5 s7-0.9,9.9-2.5c0.2-0.1,0.4-0.2,0.6-0.3c6-3.6,10-10.1,10-17.7C1115.1,734.7,1114.8,732.7,1114.2,730.7"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs89 || (_defs89 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_177_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_178_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_177_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs90 || (_defs90 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_179_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_180_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_179_",
    style: {
      overflow: "visible"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M1203.6,543.3c0,7.7-1.7,15-4.8,21.5c-8,16.9-25.2,28.5-45.2,28.5c-0.3,0-0.6,0-0.9,0 c-27.2-0.5-49.1-22.7-49.1-50c0-27.6,22.4-50,50-50S1203.6,515.7,1203.6,543.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs91 || (_defs91 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_181_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_182_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_181_",
    style: {
      overflow: "visible"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M1198.8,564.8c-8,16.9-25.2,28.5-45.2,28.5c-0.3,0-0.6,0-0.9,0c-11.2-11.2-32.1-32.2-32.1-32.2h4l8.5,8.6 h40.7l8.5-8.6h4.3v-8.4L1198.8,564.8z"
  })))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "1153.6,503.6 1149.4,503.6 1149.4,515.4 1153.6,515.4 1157.8,515.4 1157.8,503.6 "
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1120.6,
    y: 552.8,
    className: "st46",
    width: 66,
    height: 8.4
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "1182.3,561.2 1173.8,569.8 1133.1,569.8 1124.6,561.2 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs92 || (_defs92 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_183_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_184_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_183_",
    style: {
      overflow: "visible"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1155.3,520.5c0,0.9-0.7,1.7-1.7,1.7c-0.9,0-1.7-0.7-1.7-1.7c0-0.9,0.7-1.7,1.7-1.7 C1154.6,518.9,1155.3,519.6,1155.3,520.5"
  }))), /*#__PURE__*/React.createElement("g", null, _defs93 || (_defs93 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_185_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_186_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_185_",
    style: {
      overflow: "visible"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M1155.3,527.4c0,0.9-0.7,1.7-1.7,1.7c-0.9,0-1.7-0.7-1.7-1.7c0-0.9,0.7-1.7,1.7-1.7 C1154.6,525.7,1155.3,526.5,1155.3,527.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs94 || (_defs94 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_187_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_188_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_187_",
    style: {
      overflow: "visible"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M1155.3,534.1c0,0.9-0.7,1.7-1.7,1.7c-0.9,0-1.7-0.7-1.7-1.7c0-0.9,0.7-1.7,1.7-1.7 C1154.6,532.4,1155.3,533.1,1155.3,534.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs95 || (_defs95 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_189_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_190_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_189_",
    style: {
      overflow: "visible"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M1155.3,540.9c0,0.9-0.7,1.7-1.7,1.7c-0.9,0-1.7-0.7-1.7-1.7c0-0.9,0.7-1.7,1.7-1.7 C1154.6,539.2,1155.3,540,1155.3,540.9"
  }))), /*#__PURE__*/React.createElement("g", null, _defs96 || (_defs96 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_191_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_192_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_191_",
    style: {
      overflow: "visible"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M1155.3,547.7c0,0.9-0.7,1.7-1.7,1.7c-0.9,0-1.7-0.7-1.7-1.7c0-0.9,0.7-1.7,1.7-1.7 C1154.6,546,1155.3,546.8,1155.3,547.7"
  }))), /*#__PURE__*/React.createElement("g", null, _defs97 || (_defs97 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_193_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_194_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_193_",
    style: {
      overflow: "visible"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M1140.3,526.8c-0.5,0.8-1.6,0.9-2.3,0.4c-0.8-0.5-0.9-1.6-0.4-2.3c0.5-0.8,1.6-0.9,2.3-0.4 C1140.7,525,1140.9,526,1140.3,526.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs98 || (_defs98 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_195_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_196_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_195_",
    style: {
      overflow: "visible"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M1144.3,521.2c-0.5,0.8-1.6,0.9-2.3,0.4c-0.8-0.5-0.9-1.6-0.4-2.3c0.5-0.8,1.6-0.9,2.3-0.4 C1144.6,519.4,1144.8,520.5,1144.3,521.2"
  }))), /*#__PURE__*/React.createElement("g", null, _defs99 || (_defs99 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_197_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_198_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_197_",
    style: {
      overflow: "visible"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M1136.4,532.4c-0.5,0.8-1.6,0.9-2.3,0.4c-0.8-0.5-0.9-1.6-0.4-2.3c0.5-0.8,1.6-0.9,2.3-0.4 C1136.7,530.6,1136.9,531.6,1136.4,532.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs100 || (_defs100 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_199_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_200_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_199_",
    style: {
      overflow: "visible"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M1132.5,537.8c-0.5,0.8-1.6,0.9-2.3,0.4c-0.8-0.5-0.9-1.6-0.4-2.3c0.5-0.8,1.6-0.9,2.3-0.4 C1132.9,536,1133,537.1,1132.5,537.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs101 || (_defs101 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_201_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_202_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_201_",
    style: {
      overflow: "visible"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M1128.5,543.4c-0.5,0.8-1.6,0.9-2.3,0.4c-0.8-0.5-0.9-1.6-0.4-2.3c0.5-0.8,1.6-0.9,2.3-0.4 C1128.9,541.6,1129.1,542.6,1128.5,543.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs102 || (_defs102 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_203_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_204_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_203_",
    style: {
      overflow: "visible"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M1124.6,548.9c-0.5,0.8-1.6,0.9-2.3,0.4c-0.8-0.5-0.9-1.6-0.4-2.3c0.5-0.8,1.6-0.9,2.3-0.4 C1125,547.1,1125.2,548.1,1124.6,548.9"
  }))), /*#__PURE__*/React.createElement("g", null, _defs103 || (_defs103 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_205_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_206_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_205_",
    style: {
      overflow: "visible"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M1167.6,526.8c0.5,0.8,1.6,0.9,2.3,0.4c0.8-0.5,0.9-1.6,0.4-2.3c-0.5-0.8-1.6-0.9-2.3-0.4 C1167.3,525,1167.1,526,1167.6,526.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs104 || (_defs104 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_207_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_208_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_207_",
    style: {
      overflow: "visible"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M1163.7,521.2c0.5,0.8,1.6,0.9,2.3,0.4c0.8-0.5,0.9-1.6,0.4-2.3c-0.5-0.8-1.6-0.9-2.3-0.4 C1163.3,519.4,1163.1,520.5,1163.7,521.2"
  }))), /*#__PURE__*/React.createElement("g", null, _defs105 || (_defs105 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_209_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_210_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_209_",
    style: {
      overflow: "visible"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M1171.6,532.4c0.5,0.8,1.6,0.9,2.3,0.4c0.8-0.5,0.9-1.6,0.4-2.3c-0.5-0.8-1.6-0.9-2.3-0.4 C1171.2,530.6,1171,531.6,1171.6,532.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs106 || (_defs106 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_211_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_212_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_211_",
    style: {
      overflow: "visible"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M1175.4,537.8c0.5,0.8,1.6,0.9,2.3,0.4c0.8-0.5,0.9-1.6,0.4-2.3c-0.5-0.8-1.6-0.9-2.3-0.4 S1174.9,537.1,1175.4,537.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs107 || (_defs107 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_213_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_214_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_213_",
    style: {
      overflow: "visible"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M1179.4,543.4c0.5,0.8,1.6,0.9,2.3,0.4c0.8-0.5,0.9-1.6,0.4-2.3c-0.5-0.8-1.6-0.9-2.3-0.4 C1179.1,541.6,1178.9,542.6,1179.4,543.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs108 || (_defs108 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_215_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_216_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_215_",
    style: {
      overflow: "visible"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M1183.3,548.9c0.5,0.8,1.6,0.9,2.3,0.4c0.8-0.5,0.9-1.6,0.4-2.3c-0.5-0.8-1.6-0.9-2.3-0.4 C1183,547.1,1182.8,548.1,1183.3,548.9"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs109 || (_defs109 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_217_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_218_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_217_",
    style: {
      overflow: "visible"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M162.8,2808.2c1.9,0,3.5-1.6,3.5-3.5s-1.6-3.5-3.5-3.5s-3.5,1.6-3.5,3.5 C159.3,2806.6,160.9,2808.2,162.8,2808.2"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs110 || (_defs110 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_219_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_220_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_219_",
    style: {
      overflow: "visible"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M162.8,2828.2c1.9,0,3.5-1.6,3.5-3.5s-1.6-3.5-3.5-3.5s-3.5,1.6-3.5,3.5 C159.3,2826.6,160.9,2828.2,162.8,2828.2"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs111 || (_defs111 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_221_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_222_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_221_",
    style: {
      overflow: "visible"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M162.8,2868.2c1.9,0,3.5-1.6,3.5-3.5s-1.6-3.5-3.5-3.5s-3.5,1.6-3.5,3.5 C159.3,2866.6,160.9,2868.2,162.8,2868.2"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs112 || (_defs112 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_223_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_224_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_223_",
    style: {
      overflow: "visible"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M162.8,2908.2c1.9,0,3.5-1.6,3.5-3.5s-1.6-3.5-3.5-3.5s-3.5,1.6-3.5,3.5 C159.3,2906.6,160.9,2908.2,162.8,2908.2"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs113 || (_defs113 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_225_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_226_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_225_",
    style: {
      overflow: "visible"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M228.1,3251.8c0,0-0.1-0.1-0.2-0.1l0,0L228.1,3251.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs114 || (_defs114 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_227_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_228_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_227_",
    style: {
      overflow: "visible"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M228.5,3252.2l-0.4-0.4C228.3,3251.9,228.4,3252,228.5,3252.2"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs115 || (_defs115 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_229_",
    x: -0.6,
    y: -189.7,
    width: 1280,
    height: 4946
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_230_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_229_",
    style: {
      overflow: "visible"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M1078.4,3646.6L1078.4,3646.6L1078.4,3646.6L1078.4,3646.6z"
  })))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M698.7,538c-5,28.1-29.6,49.3-59.1,49.3c-1.8,0-3.6-0.1-5.4-0.2l-21.5-21.8h51.8v-60.9L698.7,538z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M699.6,528.6c0,9.2-2,17.9-5.7,25.6c-9.5,20.1-30,34-53.9,34c-0.4,0-0.7,0-1.1,0 c-32.4-0.6-58.5-27.1-58.5-59.6c0-32.9,26.7-59.6,59.6-59.6S699.6,495.7,699.6,528.6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 629.1,
    y: 509.1,
    className: "st86",
    width: 19.1,
    height: 14.7
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "648.2,494.5 648.2,509.1 629.1,509.1 629.1,494.5 633.9,494.5 633.9,484.2 631.5,484.2 631.5,479.4  633.9,479.4 633.9,474.6 643.4,474.6 643.4,479.4 645.8,479.4 645.8,484.2 643.4,484.2 643.4,494.5 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "617.5,534.8 617.5,543.4 617.5,560.5 659.8,560.5 659.8,543.4 659.8,534.8 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "664.6,504.3 664.6,565.3 612.7,565.3 612.7,504.3 617.5,504.3 617.5,560.5 659.8,560.5 659.8,504.3  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsHomeGripsNeu);
export default __webpack_public_path__ + "static/media/icons-home-grips-neu.f985c2017c13284fe93384eeb57fc1d9.svg";
export { ForwardRef as ReactComponent };